import PropTypes from "prop-types"
import { Flex, Checkbox } from "antd"
import { UserOutlined, FilePdfOutlined } from "@ant-design/icons"
import TicketTypeIcon from "../BookingTable/TicketTypeIcon"
import BookingTag from "../BookingTag"
import PaymentTag from "../PaymentTag"
import styles from "./ReservationCard.module.css"

// Mobile card for a Reservation row. The check-in/out badge and the selection checkbox act on
// their own (mirroring the desktop table); tapping the body opens the reservation detail.
const ReservationCard = ({ item, onView, badge, checked = false, onToggleSelect }) => (
  <div className={styles.card}>
    <Flex align="center" gap={8} className={styles.topRow}>
      {badge}
      <span className={styles.clientName} title={item.name}>{item.name}</span>
      <Flex align="center" gap={4} className={styles.guests}>
        <UserOutlined className={styles.metaIcon} />
        <span className={styles.guestCount}>{item.guestCount}</span>
      </Flex>
      <span className={styles.bookingId}>{item.bookingId}</span>
    </Flex>

    <Flex align="flex-start" gap={8} className={styles.bodyRow}>
      <Checkbox
        checked={checked}
        onChange={(event) => onToggleSelect?.(event.target.checked)}
        className={styles.checkbox}
      />
      <button type="button" className={styles.body} onClick={() => onView(item)}>
        <Flex align="flex-start" justify="space-between" gap={8}>
          {item.experience && <span className={styles.experience} title={item.experience}>{item.experience}</span>}
          <TicketTypeIcon isGroup={item.experienceIsGroup} />
        </Flex>
        <span className={styles.dateTime}>
          {[item.experienceDate, item.experienceTime].filter(Boolean).join(" · ")}
        </span>
        {(item.paymentTag || item.collectionTag) && (
          <Flex align="center" gap={8} wrap="wrap" className={styles.tags}>
            {item.paymentTag && <PaymentTag label={item.paymentTag.label} color={item.paymentTag.color} />}
            {item.collectionTag && <PaymentTag label={item.collectionTag.label} color={item.collectionTag.color} />}
          </Flex>
        )}
        <BookingTag color={item.docsSign >= item.docsTotal ? "success" : "error"} className={styles.docsTag}>
          <Flex align="center" gap={4}>
            <FilePdfOutlined />
            {item.docsSign}/{item.docsTotal}
          </Flex>
        </BookingTag>
      </button>
    </Flex>
  </div>
)

ReservationCard.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    bookingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    experience: PropTypes.string,
    experienceDate: PropTypes.string,
    experienceTime: PropTypes.string,
    experienceIsGroup: PropTypes.bool,
    guestCount: PropTypes.number,
    paymentTag: PropTypes.shape({ label: PropTypes.string, color: PropTypes.string }),
    collectionTag: PropTypes.shape({ label: PropTypes.string, color: PropTypes.string }),
    docsSign: PropTypes.number,
    docsTotal: PropTypes.number
  }).isRequired,
  onView: PropTypes.func.isRequired,
  badge: PropTypes.node,
  checked: PropTypes.bool,
  onToggleSelect: PropTypes.func
}

export default ReservationCard
